import { apiPrefix, baseUrl } from '../config';
export const buildApiUrl = (endpoint, customBaseUrl = baseUrl, customApiPrefix = apiPrefix) => {
    return `${customBaseUrl}${customApiPrefix}${endpoint}`;
};
